"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _get = _interopRequireDefault(require("./get"));

var _set = _interopRequireDefault(require("./set"));

var _pipeWith = _interopRequireDefault(require("./util/pipeWith"));

var _default = (0, _unmutable.default)({
  name: 'swap',
  all: function all(keyA, keyB) {
    return function (value) {
      return (0, _pipeWith.default)(value, (0, _set.default)(keyA, (0, _get.default)(keyB)(value)), (0, _set.default)(keyB, (0, _get.default)(keyA)(value)));
    };
  }
});

exports.default = _default;